module.exports = __webpack_public_path__ + "svg/file_pdf_no_arrow.13c6ffc5ec30a458bf49c00dfe8f83fc.svg";